export default "__VITE_ASSET__Bqp_wzL___"